import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GraduationCap, LogIn } from "lucide-react";
import ProfileDropdown from "./ProfileDropdown";

export default function NavBar() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const stored = localStorage.getItem("user");
      setUser(stored ? JSON.parse(stored) : null);
    } catch {
      setUser(null);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("session_token");
    localStorage.removeItem("user_subject_selection");
    localStorage.removeItem("subjectSelection");
    setUser(null);
    window.location.href = "/";
  };

  const handleUserUpdate = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem("user", JSON.stringify(updatedUser));
  };

  return (
    <div className="bg-white border-b shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-4">
        {/* LEFT: Brand */}
        <button
          onClick={() => navigate("/category")}
          data-testid="navbar-brand"
          className="flex items-center gap-2 text-gray-700 hover:text-blue-600 transition-colors"
        >
          <GraduationCap className="w-5 h-5 text-blue-600" />
          <span className="font-bold text-gray-800 text-sm sm:text-base hidden sm:block">
            Descriptive Test
          </span>
        </button>

        {/* RIGHT: Profile avatar / Sign In button */}
        <div className="flex items-center gap-3">
          {user ? (
            <ProfileDropdown
              user={user}
              onUserUpdate={handleUserUpdate}
              onLogout={handleLogout}
            />
          ) : (
            <button
              onClick={() => window.location.href = "/"}
              data-testid="navbar-login-btn"
              className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-700 transition-colors"
            >
              <LogIn className="w-4 h-4" />
              Sign In
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
